const getters = {
  getInvoiceData: state => {
    return state.invoiceData
  }
}
export default getters
